import { render, staticRenderFns } from "./OtherMain.vue?vue&type=template&id=038be895&scoped=true&"
import script from "./OtherMain.vue?vue&type=script&lang=js&"
export * from "./OtherMain.vue?vue&type=script&lang=js&"
import style0 from "./OtherMain.vue?vue&type=style&index=0&id=038be895&prod&lang=scss&scoped=true&"
import style1 from "./OtherMain.vue?vue&type=style&index=1&id=038be895&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038be895",
  null
  
)

export default component.exports